import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import type { History } from 'history';
import { useDispatch, useSelector } from 'react-redux';
import Loader from 'modus/components/misc/Loader';
import AuthService from '../../services/authService';

interface User {
  access_token?: string;
}

interface RootState {
  auth: {
    loading: boolean;
    error: any;
  };
}

const SigninCallback: React.FC = () => {
  const history = useHistory<History>();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const user = await AuthService.signinRedirectCallback();
        
        if (user?.access_token) {
          let loadedUrl = localStorage.getItem('LoadedUrl') || '/home';
          localStorage.removeItem('LoadedUrl');

          const excludedPaths = ['/landing', '/login', '/callback', '/error'];
          if (excludedPaths.some(str => loadedUrl.includes(str))) {
            loadedUrl = '/home';
          }

          history.push(loadedUrl);
        } else {
          AuthService.login();
        }
      } catch (error) {
        console.error('Error during callback:', error);
        // Redirect to login to retry authentication
        AuthService.login();
      }
    };

    if (history) {
      handleCallback();
    }
  }, [history, dispatch]);

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <h2>Authentication Error</h2>
        <p>There was an error during authentication. Redirecting to login...</p>
        <Loader showBackDrop message="Redirecting..." />
      </div>
    );
  }

  return (
    <div>
      <Loader showBackDrop message={loading ? "Processing authentication..." : "Redirecting..."} />
    </div>
  );
};

export default SigninCallback;
